<section class="wrapper" [ngStyle]="{width: width}">
    <div #carouselOutterContainer class="js-carousel">
        <div #carouselPanel class="js-carousel -panes" [ngClass]="config">
            <ng-content></ng-content>
        </div>
    </div>

    <div class="sg-chevron sg-rounded -left" [class.-disabled]="carService.leftArrowDisabled$ | async" (click)="moveCarousel('left')">
        <mlp-ng-icon name="arrow-left-1"></mlp-ng-icon>
    </div>

    <div class="sg-chevron sg-rounded -right" [class.-disabled]="carService.rightArrowDisabled$ | async" (click)="moveCarousel('right')">
        <mlp-ng-icon name="arrow-right-1"></mlp-ng-icon>
    </div>
</section>
